// extracted by mini-css-extract-plugin
module.exports = {"imageBanner":"imageBanner-module--imageBanner--1X9Ph","bannerText":"imageBanner-module--bannerText--cPLAh"};